import { apiSlice } from "./apiSlice";

export const financialDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all HSE list
        getFinancialDashboardData: builder.query({
            query: (params) => ({
                url: `FinancialDashboard`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllFinancialDashboardData"],
        }),

        // Create new HSE


    })
})

export const { useGetFinancialDashboardDataQuery, useLazyGetFinancialDashboardDataQuery, } = financialDashboardSlice;
